import React, { createContext, useContext } from 'react';

type FeatureFlagMap = Record<string, string | null>;

const FeatureFlagContext = createContext<FeatureFlagMap>({});

export const useFeatureFlag = (flagName: string, expectedVersion?: string): boolean => {
  const flags = useContext(FeatureFlagContext);
  const activeVersion = flags[flagName];

  if (!activeVersion || activeVersion === 'disabled') return false;

  return expectedVersion ? activeVersion === expectedVersion : true;
};

export const useFeatureFlagVersion = (flagName: string): string | null => {
  const flags = useContext(FeatureFlagContext);
  const version = flags[flagName];

  return version && version !== 'disabled' ? version : null;
};

export const FeatureFlagProvider: React.FC<{
  flags: FeatureFlagMap;
  children: React.ReactNode;
}> = ({ flags, children }) => (
  <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>
);

export const useAllFeatureFlags = (): FeatureFlagMap => {
  return useContext(FeatureFlagContext);
};
